import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import RainbowServerFetch from "../Request/RainbowServerFetch";
import * as constants from "../Constants/SdkConstant";

const LOG_TAG = "SERVICE:DEVELOPERS";

export const getDevelopersPerPage = (page, limit, criteria) => {
    LogService.trace(LOG_TAG, "getDevelopersPerPage");

    let queryParameters = "?offset=" + String(limit * page);
    queryParameters += "&limit=" + Math.min(limit, constants.MAX_PAGE_SIZE);
    let hasFormatCriteria = false;

    for (let key in criteria) {
        queryParameters += "&" + key + "=" + criteria[key];
        if (key === "format") {
            hasFormatCriteria = true;
        }
    }

    if (!hasFormatCriteria) {
        queryParameters += "&format=medium";
    }

    return RainbowServerFetch.get("/api/rainbow/applications/v1.0/developers" + queryParameters)
        .then(response => {
            LogService.info(LOG_TAG, "getDevelopersPerPage", "success");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getDevelopersPerPage", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const createSandBoxAdminAccount = () => {
    LogService.trace(LOG_TAG, "createSandBoxAdminAccount");

    return RainbowServerFetch.post("/api/rainbow/applications/v1.0/sandbox/developers")
        .then(response => {
            LogService.info(LOG_TAG, "createSandBoxAdminAccount", "success");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "createSandBoxAdminAccount", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getSandBoxInformations = () => {
    LogService.trace(LOG_TAG, "getSandBoxInformations");

    return RainbowServerFetch.get("/api/rainbow/applications/v1.0/sandbox/info")
        .then(response => {
            LogService.info(LOG_TAG, "getSandBoxInformations", "success");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getSandBoxInformations", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}